

































































import { ItemKit, Produto, ProdutosService } from "@/services/produtos.service";
import DatePicker from "@/shared/components/date-picker.vue";
import InputMoeda from "@/shared/components/input-moeda.vue";
import Loading from "@/shared/components/loading.vue";
import TreeSelectCategorias from "@/shared/components/tree-select-categorias.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { maiorQue, required } from "@/shared/validators";
import { Component, Mixins, Prop } from "vue-property-decorator";
import SelectSecao from "./SelectSecao.vue";
import SelectTipoProduto from "./SelectTipoProduto.vue";

@Component({
  components: {
    Loading,
    InputMoeda,
    TreeSelectCategorias,
    SelectTipoProduto,
    DatePicker,
    SelectSecao,
  },
})
export default class FormProduto extends Mixins(GlobalMixin) {
  @Prop() produto!: Produto;
  @Prop() comHistorico!: boolean;

  itemsKit = [] as ItemKit[];
  rules = {
    descricao: [required()],
    codigoFornecedor: [required()],
    moeda: [required()],
    tipo: [required()],
    validoApos: [required()],
    secao: [required()],
    alertaVencimentoEmDias: [maiorQue(-1)],
  };

  get editando() {
    return this.produto?.idProduto != null;
  }

  async salvarProduto() {
    const form = this.$refs.form as any;
    if (form.validate() && this.produto) {
      this.startLoader();
      let newProd = {} as Produto;
      if (this.comHistorico) {
        await ProdutosService.manterProdutoComHistorico(this.produto).finally(
          this.stopLoader
        );
      } else {
        newProd = await ProdutosService.manterProduto(this.produto).finally(
          this.stopLoader
        );
      }
      this.$emit("produto-atualizado", newProd);
    }
  }

  voltar() {
    this.$router.back();
  }
}
